import { render, staticRenderFns } from "./zuo27.vue?vue&type=template&id=355b0900&scoped=true&"
import script from "./zuo27.vue?vue&type=script&lang=js&"
export * from "./zuo27.vue?vue&type=script&lang=js&"
import style0 from "./zuo27.vue?vue&type=style&index=0&id=355b0900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b0900",
  null
  
)

export default component.exports